export const getRequiredFieldsFilters = state => state.requiredFields.requiredFieldsFilters;

export const getRequiredFieldsGridSortCriteria = state =>
  state.requiredFields.requiredFieldsGridSortCriteria;
